import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { TreeType } from 'shared/util-common';

import { TaxonomyDto } from '@treetop/shared/model';

@Injectable({
  providedIn: 'root',
})
export class TreeService {
  private definitionSubject = new BehaviorSubject<TaxonomyDto>(null);
  private guidelineSubject = new BehaviorSubject<TaxonomyDto>(null);
  private smartbookSubject = new BehaviorSubject<TaxonomyDto>(null);

  activeNodeDefinition$: Observable<TaxonomyDto> = this.definitionSubject.asObservable();

  setActiveNode(node: TaxonomyDto, treeType: TreeType): void {
    switch (treeType) {
      case TreeType.definition:
        if (this.definitionSubject.getValue() === node) {
          this.definitionSubject.next(null);
        } else {
          this.definitionSubject.next(node);
        }
        return;
      case TreeType.guideline:
        if (this.guidelineSubject.getValue() === node) {
          this.guidelineSubject.next(null);
        } else {
          this.guidelineSubject.next(node);
        }
        return;
      case TreeType.smartbook:
        if (this.smartbookSubject.getValue() === node) {
          this.smartbookSubject.next(null);
        } else {
          this.smartbookSubject.next(node);
        }
        return;
    }
  }
}
